/**
 * CJK text detection for PDF font selection.
 *
 * pdfmake's embedded Roboto has no CJK glyphs (they render as tofu squares),
 * so text containing CJK characters must be rendered with a CJK-capable font.
 *
 * Pure, framework-agnostic module: no Vue imports, no side effects.
 * Ported from cartadigital-pos (app/domain/invoicing/cjk-text.ts);
 * keep both copies logically identical.
 */

/**
 * pdfmake font family name for the CJK-capable font (WenQuanYi Micro Hei).
 * Registered lazily by the pdf-engine only when a document needs it.
 */
export const CJK_PDF_FONT = 'WQYMicroHei';

/**
 * Unicode ranges Roboto cannot render that WenQuanYi Micro Hei covers:
 * Hangul Jamo, CJK radicals/Kangxi, CJK symbols and punctuation, kana,
 * Hangul compatibility Jamo, CJK Unified Ideographs (+ Ext A/B..F),
 * Hangul syllables, compatibility ideographs/forms and full-width forms.
 */
const CJK_PATTERN =
  /[\u1100-\u11FF\u2E80-\u2FDF\u3000-\u30FF\u3130-\u318F\u3400-\u4DBF\u4E00-\u9FFF\uAC00-\uD7AF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u{20000}-\u{2FA1F}]/u;

export function containsCjk(value: string): boolean {
  return CJK_PATTERN.test(value);
}
